<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        
        <div>
            <v-text-field
                        label="Lesson name:"
                        v-model="mycontent.name"
                    ></v-text-field>                          
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
                mycontent:  {
                    name: 'loading...'
                },
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getContentUni'
                        ])
    ,
    methods: {
        /************************************************************ */
        saveActualContent(mylang) {   
            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContentUni', data)            
        },

        refreshData() {
            // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContentUnifromStore(lang_id) {
            return this.getContentUni(lang_id)
        },

        readFromStore() {
            var con = -1
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                con = this.getContentUnifromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                con = this.getContentUnifromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        }
    } 

}
</script>


<style>

</style>

